export { default } from './BannerSmall';
